import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { setIsQuickDepositAvailable } from 'js/components/system/App/store/actions';

export const useLegacyQuickDepositListener = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const setQuickDepositAvailability = payload => dispatch(setIsQuickDepositAvailable(payload));

        dispatcher.listen('quickDeposit:setIsAvailable', setQuickDepositAvailability);

        return () => {
            dispatcher.removeListener('quickDeposit:setIsAvailable', setQuickDepositAvailability);
        };
    }, [dispatch]);
};
